var _Path, _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
var SvgFork = function SvgFork(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "fork_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#fork_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M12 21.75a.726.726 0 0 1-.535-.215.726.726 0 0 1-.215-.535v-4c0-.92-.135-1.625-.406-2.114-.27-.488-.652-.952-1.144-1.392l1.07-1.069c.212.196.425.424.637.684.212.26.41.535.593.826.214-.362.461-.696.741-1.001.28-.306.571-.595.873-.867a8.83 8.83 0 0 0 1.86-2.38c.503-.927.759-2.41.766-4.449l-1.298 1.298a.709.709 0 0 1-.519.218.76.76 0 0 1-.762-.752.718.718 0 0 1 .228-.535l2.478-2.479A.829.829 0 0 1 17 2.733a.829.829 0 0 1 .633.256l2.494 2.494c.145.145.22.318.225.519a.708.708 0 0 1-.225.534.718.718 0 0 1-.527.218.718.718 0 0 1-.527-.218L17.74 5.22c-.007 2.313-.321 4.031-.941 5.155-.62 1.124-1.34 2.06-2.162 2.809a9.83 9.83 0 0 0-1.358 1.484c-.353.488-.529 1.265-.529 2.333v4a.726.726 0 0 1-.215.535.726.726 0 0 1-.535.215ZM6.479 8.002a8.738 8.738 0 0 1-.157-1.264A35.969 35.969 0 0 1 6.26 5.22L4.927 6.552a.709.709 0 0 1-.52.217.735.735 0 0 1-.534-.233.717.717 0 0 1-.217-.526c0-.207.072-.382.217-.527l2.494-2.495A.83.83 0 0 1 7 2.733a.83.83 0 0 1 .633.256l2.494 2.494a.705.705 0 0 1 .22.522.743.743 0 0 1-.236.531.748.748 0 0 1-.526.208.748.748 0 0 1-.527-.208L7.76 5.254c-.007.452.008.889.045 1.31.036.42.08.783.133 1.088l-1.46.35Zm2.006 4.313a8.746 8.746 0 0 1-.876-1.181 7.226 7.226 0 0 1-.707-1.5l1.444-.359c.141.386.315.745.522 1.078.207.333.436.63.686.893l-1.07 1.07Z",
    fill: "currentColor"
  }))));
};
export default SvgFork;